import React, {Component} from 'react';
import fetch from 'isomorphic-fetch';
import {withRouter} from 'react-router-dom';
import {commonHeaders} from '../../../actions/fetch.util';
import {Button, ButtonGroup, PageForm} from '../../Common/PageComponents';

class PasswordResetForm extends Component {
  componentDidMount() {
    this.form.userName.focus();
  }

  _requestResetPassword(e) {
    e.preventDefault();

    if (!this.form.userName.value || !this.form.ownerName.value || !this.form.businessLicenseNumber.value) {
      alert('아이디, 대표자 성명, 사업자등록번호를 모두 입력해주세요.');
      return;
    }

    fetch(
      `${API_URL}/users/by-user-name/${this.form.userName.value}/by-owner-name/${this.form.ownerName.value}/by-business-license-number/${this.form.businessLicenseNumber.value}/temporal-password`,
      {
        method: 'POST',
        headers: commonHeaders(),
      }
    )
      .then(response => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 404) {
          return;
        } else {
          throw new Error();
        }
      })
      .catch(() => {})
      .then(result => {
        if (result) {
          this.props.history.push(
            `/member-service/password-reset/result?maskedEmailAddress=${result.maskedEmailAddress}`
          );
        } else {
          this.props.history.push(`/member-service/password-reset/result`);
        }
      });
  }

  render() {
    return (
      <div>
        <PageForm theme={'box'} style={{margin: '50px auto'}}>
          <form action="/member-service/id-search/result" method="post" name="frm" ref={form => (this.form = form)}>
            <dl>
              <dt>아이디</dt>
              <dd>
                <input
                  type="text"
                  className="input_text"
                  name="userName"
                  id="userName"
                  maxLength="16"
                  style={{imeMode: 'disabled', width: '250px'}}
                  autoComplete="off"
                />
              </dd>
              <dt>대표자 성명</dt>
              <dd>
                <input
                  type="text"
                  className="input_text"
                  name="ownerName"
                  id="ownerName"
                  maxLength="25"
                  autoComplete="off"
                  style={{width: '250px'}}
                />
              </dd>
              <dt>사업자등록번호</dt>
              <dd>
                <input
                  type="text"
                  className="input_text"
                  name="businessLicenseNumber"
                  maxLength="12"
                  style={{width: '250px'}}
                  placeholder=" 예) 123-45-67890"
                  autoComplete="off"
                />
              </dd>
            </dl>
          </form>
          <ButtonGroup>
            <Button onClick={e => this._requestResetPassword(e)}>확인</Button>
          </ButtonGroup>
        </PageForm>
        <p className="pw_s_tx">
          <img src="/image/member/pw_s_ok.gif" alt="" />
          ‘사업자등록증 미발급’ 선택을 통해 회원가입하신 분들은 <strong>고객센터(1688-1011)</strong>로 문의 주시기
          바랍니다.{' '}
        </p>
      </div>
    );
  }
}

export default withRouter(PasswordResetForm);
